import { h1 } from '@paypalcorp/pp-react'
import React from 'react'

const DummyTempComponent = () => {
  return <h1>Template Component to be replaced with real screens.</h1>
}

export default DummyTempComponent
